import { SET_DATA_CASH, ADD_DATA_CASH, UPDATE_DATA_CASH, REMOVE_DATA_CASH } from "./actionTypes"

export const setDataCash = (data) => {
  return {
    type: SET_DATA_CASH,
    payload: data
  };
};


export const addDataCash = (data) => {
    return {
      type: ADD_DATA_CASH,
      payload: data
    };
  };

// Un movimiento que cambió (por ejemplo, se le corrigió la forma de pago).
// El documento se modifica en el lugar, así que hay que reemplazarlo — no
// agregarlo — para no duplicarlo ni perder su posición en la sesión.
export const updateDataCash = (data) => {
  return {
    type: UPDATE_DATA_CASH,
    payload: data
  };
};

export const removeDataCash = (data) => {
  return {
    type: REMOVE_DATA_CASH,
    payload: data
  };
};
